import { TabView, TabPanel } from 'primereact/tabview';
import CostElementView from './CostElement';
import WorkCenterView from './WorkCenter';
import RateDefaultView from './RateDefault';
import { Card } from 'primereact/card';

export default function Costing() {
    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Card className="layout-main-card border-noround">
                    <TabView>
                        <TabPanel header="Cost Element">
                            <CostElementView/>
                        </TabPanel>
                        <TabPanel header="Work Center">
                            <WorkCenterView/>
                        </TabPanel>
                        <TabPanel header="Rate Default">
                            <RateDefaultView/>
                        </TabPanel>
                    </TabView>
                </Card>
            </div>
        </div>
    )
}